
export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "requirement.specimenType" } ]
      },
      {
        "fields": [ { "name": "requirement.anatomicSite" } ]
      },
      {
        "fields": [ { "name": "requirement.pathologyStatuses" } ]
      },
      {
        "fields": [ { "name": "requirement.clinicalDiagnosis" } ]
      },
      {
        "fields": [ { "name": "requirement.specimenCount" } ]
      },
      {
        "fields": [ { "name": "requirement.quantity" } ]
      },
      {
        "fields": [ { "name": "requirement.cost" } ]
      },
      {
        "fields": [ { "name": "requirement.comments" } ]
      }
    ]
  }
}
